/**
 * Interface for map selection request
 */
export interface MapSelectionRequest {
  id: string; // Composed ID: component + UUID (e.g., 'search-enhanced-abc123')
  type: "point" | "polygon" | "circle" | "square";
  data?: any; // Additional data needed for the request
}

export interface MapActionRequest {
  type: "search";
  data?: MapActionData; // Additional data needed for the request
}

export interface MapActionData {
  type: "move" | "fit";
  coordinates?: {
    lat: number;
    lng: number;
  };

  /** Geometry data for WKT_GEOMETRY type */
  geometry?: {
    wkt?: string;
    boundingBox?: [number, number, number, number];
  };
}

/**
 * Interface for map selection result
 */
export interface MapSelectionResult {
  id: string;
  type: MapSelectionRequest["type"];
  wkt: string | null; // null = cancelled
  previewUrl?: string | null;
  data?: any; // Additional data returned from the selection
}

/**
 * Enumeration for map selection types
 */
export enum MapSelectionType {
  POINT = "point",
  POLYGON = "polygon",
  CIRCLE = "circle",
  SQUARE = "square",
}
